module.exports = __webpack_public_path__ + "img/badge_software_gold.9a7314c5.png";